export default "__VITE_ASSET__00fbc221__"